/* ============================================================================
   iws-inventory-countdown.js
   ----------------------------------------------------------------------------
   Companion JS de snippets/iws-inventory-countdown.liquid.

   O Liquid já renderiza o valor real (estoque) no servidor. Este script só
   entra em ação quando o container tem [data-iws-ic] (ou seja: o produto tem
   `custom.promo_curve` preenchido E a seção/bloco tem `iws_promo_date`
   configurada, dentro do dia da promoção). Fora disso, não faz nada — a
   página fica exatamente como já era.

   Regra aplicada quando ativo: exibe SÓ a curva da promoção, ignorando o
   estoque real por completo enquanto o dia da promoção estiver em andamento
   (decisão explícita — reverte a regra "maior dos dois" da primeira versão).
   Fora do dia da promoção, sem mudança: só estoque real, como sempre foi.

   QA (?iws_ic_now=2026-08-22T14:30:00-03:00): só é aceito quando
   Shopify.designMode estiver true (editor de tema) ou o tema atual não for o
   tema live (Shopify.theme.role !== 'main', ou seja: tema de dev/preview).
   Nunca usa localStorage nem valor aleatório — o mesmo querystring produz o
   mesmo resultado em qualquer aparelho.
   ============================================================================ */
(function () {
  'use strict';

  function isQaAllowed() {
    try {
      if (!window.Shopify) return false;
      if (window.Shopify.designMode === true) return true;
      if (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return true;
    } catch (e) {}
    return false;
  }

  function getNowMs() {
    if (isQaAllowed()) {
      var params = new URLSearchParams(window.location.search);
      var override = params.get('iws_ic_now');
      if (override) {
        var parsed = new Date(override).getTime();
        if (!isNaN(parsed)) return parsed;
      }
    }
    return Date.now();
  }

  function fmtPct(n) {
    var rounded = Math.round(n * 10) / 10;
    if (Math.round(rounded) === rounded) return String(Math.round(rounded));
    return String(rounded).replace('.', ',');
  }

  function curvePercent(anchors, smooth, nowMs) {
    if (!anchors || !anchors.length) return null;

    var first = anchors[0];
    var last = anchors[anchors.length - 1];

    if (nowMs < first.t) return first.pct;
    if (nowMs >= last.t) return last.pct;

    for (var i = anchors.length - 2; i >= 0; i--) {
      if (nowMs >= anchors[i].t) {
        if (smooth) {
          var frac = (nowMs - anchors[i].t) / (anchors[i + 1].t - anchors[i].t);
          return anchors[i].pct + (anchors[i + 1].pct - anchors[i].pct) * frac;
        }
        return anchors[i].pct;
      }
    }
    return first.pct;
  }

  function applyOne(container, nowMs) {
    var dayStart = parseInt(container.getAttribute('data-iws-ic-day-start'), 10);
    var dayEnd = parseInt(container.getAttribute('data-iws-ic-day-end'), 10);
    if (isNaN(dayStart) || isNaN(dayEnd)) return;

    // Fora do dia da promoção -> só estoque real. Reverte sozinho no dia seguinte.
    if (nowMs < dayStart || nowMs >= dayEnd) return;

    var smooth = container.getAttribute('data-iws-ic-smooth') === 'true';
    var anchors;
    try {
      anchors = JSON.parse(container.getAttribute('data-iws-ic-anchors') || '[]');
    } catch (e) {
      return;
    }
    if (!anchors.length) return;

    var pctEl = container.querySelector('[data-iws-ic-pct]');
    var fillEl = container.querySelector('[data-iws-ic-fill]');
    if (!pctEl || !fillEl) return;

    var curvePct = curvePercent(anchors, smooth, nowMs);
    if (curvePct === null) return;

    // Decisão explícita: enquanto a curva estiver ativa, ela manda sozinha —
    // não compara mais com o estoque real (data-iws-ic-real fica só como
    // valor de fallback renderizado no servidor, antes do JS rodar).
    var finalPct = curvePct;

    fillEl.style.setProperty('width', finalPct + '%');
    pctEl.textContent = fmtPct(finalPct);
  }

  function run() {
    var nowMs = getNowMs();
    var containers = document.querySelectorAll('[data-iws-ic]');
    for (var i = 0; i < containers.length; i++) {
      applyOne(containers[i], nowMs);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);

  // Granularidade de 30s: os pontos da curva costumam ser de 30min em
  // 30min, não precisa de mais frequência que isso.
  setInterval(run, 30000);
})();
